import { getSearchParamValue } from './getSearchParamValue';
import { debug } from './debugging';
import { copyParamsToUrl } from './copyParamsToUrl';

/**
 * Returns the url of the forwarding fallback page that provides
 * country selection functionality.
 */
export function getCountrySelectionPageUrl() {
  let url = '';

  if (typeof window !== 'undefined') {
    url = window.location.href;
  }

  let hostname;
  try {
    hostname = new URL(url).hostname;
  } catch (error) {
    if (error instanceof Error) {
      debug(`getCountrySelectionPageUrl(): ${error} (url=${url})`);
    }
    hostname = '';
  }

  if (
    hostname.includes('localhost') ||
    hostname.includes('prod.renderer.one.audi') ||
    hostname.includes('pre-www.audi')
    // oneaudi-falcon-teams-stage-emea.prod.renderer.one.audi
    // author.pre-audi-co-jp.prod.renderer.one.audi
    // pre-www.audi.co.jp
    // pre-www.audi.nl
  ) {
    return createBacklink('https://stage.forward.audi.com');
  }

  return createBacklink('https://forward.audi.com');
}

function createBacklink(url: string) {
  const tagPath = getSearchParamValue('redirectTagPath');
  const urlWithTagPath = `${url}/:${tagPath}?isBacklink=true`;

  return copyParamsToUrl(urlWithTagPath, { blacklist: ['redirectTagPath'] }); // copy url params from current url / location
}
